
@if ((deviationScope$ | async); as deviationScope) {
  @if ((deviationType$ | async); as deviationType) {
    <form [formGroup]="trafficDeviationForm" (ngSubmit)="onSubmit()" #form>
      <section class="trafikhuvudman">
        <div class="section-header"><p class="title" translate>Report to public transport authority</p></div>

        <fieldset>
          @if (existingTrafficDeviationId) {
            <button mat-icon-button class="close-button" (click)="closeBlade();" type="button">
              <mat-icon>close</mat-icon>
            </button>
          }
          <div class="form-group">
            @if (existingTrafficDeviationId) {
              <div class="id">
                {{ existingTrafficDeviationId | slice:-8 }}
              </div>
            }
            @if (trafficDeviationForm.controls.version.value) {
              <div class="version">
                <span class="label">Version {{ trafficDeviationForm.controls.version.value }}: </span>
                <span class="name">{{ trafficDeviationForm.controls.userFullName.value }}</span>
              </div>
            }
            <app-traffic-deviation-receipt-status-failed
              [existingTrafficDeviationId]="existingTrafficDeviationId">
            </app-traffic-deviation-receipt-status-failed>

            <app-form-select-with-errors
              [label]="'Type of deviation'"
              [options$]="deviationTypeOptions$"
              [control]="deviationTypeOptions"
              [id]="'deviationTypeSelect'"
              [disabled]="!!existingTrafficDeviationId"
              [showValidation]="true">
            </app-form-select-with-errors>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <app-form-select-with-errors
              [label]="'Cause'"
              [options$]="deviationReasonOptions$"
              [control]="trafficDeviationForm.controls.deviationReason"
              [id]="'reasonSelect'"
              [disabled]="!!existingTrafficDeviationId && !toggleTrafficDeviationInformation$.value"
              [showValidation]="true">
            </app-form-select-with-errors>
          </div>
        </fieldset>

        <hr>

        @if (deviationScope === 'DEFAULT') {
        <app-deviation-affected></app-deviation-affected>
        }

        @if (deviationScope === 'TRIP' || deviationScope === 'COMING_TRIP') {
        <app-deviation-affected-trip [id]="existingTrafficDeviationId"></app-deviation-affected-trip>
        }
      </section>

      <section class="trafikinformation">      
        @if (!deviationType.connectionCancellation) {
          @if ({ value: toggleTrafficDeviationInformation$ | async }; as toggleTrafficDeviationInformation) {
            <fieldset class="traffic-deviation-information">
              <p class="label-above" class="title">
                {{ 'Traffic information for passengers' | translate }}
              </p>
              @if (toggleTrafficDeviationInformation.value || !(existingTrafficDeviationId && deviationType.journeyTiming)) {
                @if (!deviationType.deviationInformation) {
                  <app-form-switch
                    [checkboxValue]="toggleTrafficDeviationInformation.value"
                    (toggleCallback)="toggleTrafficDeviationInformation$.next($event)">
                  </app-form-switch>
                }
              }

              @if (!toggleTrafficDeviationInformation.value && existingTrafficDeviationId && deviationType.journeyTiming) {
                <p>{{ 'No associated disturbance information' | translate }}</p>
              }
            </fieldset>

            @if (toggleTrafficDeviationInformation.value || deviationType.deviationInformation) {
              <app-create-traffic-deviations-deviation-information>
              </app-create-traffic-deviations-deviation-information>
            }
          }
        }
      </section>

      <section class="internal-comment">
        @if ({ value: toggleInternalComment$ | async }; as toggleInternalComment) {
          <fieldset>
            <p class="label-above title">{{ 'Internal comment' | translate }}</p>
            <app-form-switch
              [checkboxValue]="toggleInternalComment.value"
              (toggleCallback)="toggleInternalComment$.next($event)">
            </app-form-switch>
          </fieldset>

          @if (toggleInternalComment.value) {
            <app-internal-comment></app-internal-comment>
          }
        }
      </section>

      @if ({
        valueChanges: trafficDeviationForm.valueChanges | async,
        existingTrafficDeviationLoaded: existingTrafficDeviationLoaded$ | async
        }; as observables) {
        @if (!observables.existingTrafficDeviationLoaded
          || observables.existingTrafficDeviationLoaded && !deviationType.connectionCancellation) {
          <div class="submit-form-wrapper">
            <app-validation-summary
              [form]="trafficDeviationForm"
              [show]="showValidationSummary"
              [additionalErrors]="additionalValidationErrors()"
            />

            <button 
              type="submit"
              [disabled]="
                  (formLoading$ | async)
                  || formSubmitted 
                  || (observables.existingTrafficDeviationLoaded && (isDirty$ | async) !== true)">
              @if (observables.existingTrafficDeviationLoaded) {
                {{ 'Update' | translate }}
              } @else {
                {{ 'Publish' | translate }}
              }
            </button>
            @if (observables.existingTrafficDeviationLoaded
              && (deviationType.journeyPattern || deviationType.predictionInaccurate)) {
              <button
                type="button"
                class="destructive"
                (click)="recallDeviation($event)">
                {{ 'Recall' | translate }}
              </button>
            }
          </div>
        }
      }

      @if ((trafficDeviationsConfig$ | async).showFormValuesAsJson) {
        <pre>{{ trafficDeviationForm.getRawValue() | json }}</pre>
      }
    </form>
  }
}